import React, { useState } from 'react';
import GoogleListingPicker from './GoogleListingPicker';
import GoogleRatingPanel from './GoogleRatingPanel';

interface ProviderGoogleSectionProps {
  providerId: number;
  placeId: string | null | undefined;
  isOwnProfile: boolean;
}

// Other visitors see the live Google rating if the provider linked a listing; the
// provider also gets the picker to link, change or remove it.
const ProviderGoogleSection: React.FC<ProviderGoogleSectionProps> = ({
  providerId,
  placeId,
  isOwnProfile,
}) => {
  const [linkedId, setLinkedId] = useState<string | null>(placeId ?? null);

  if (!isOwnProfile && !linkedId) return null;

  return (
    <section className="mb-8">
      <h2 className="font-['Ovo'] text-2xl text-[#1f1f1f] uppercase mb-4">Google rating</h2>
      {linkedId && (
        <div className="max-w-md mb-4">
          {/* Remount when the listing changes so it fetches the new one */}
          <GoogleRatingPanel key={linkedId} providerId={providerId} />
        </div>
      )}
      {isOwnProfile && <GoogleListingPicker placeId={linkedId} onChange={setLinkedId} />}
    </section>
  );
};

export default ProviderGoogleSection;
